export const DEFAULT_TIER = "fast";
export const TIER_STORAGE_KEY = "ai_assist_tier";

// Ordered highest → lowest capability. Client-side fallback walks down this list.
const TIER_FALLBACK_ORDER = ["reasoning", "standard", "fast"];

export const getFallbackTier = (currentTier) => {
  const idx = TIER_FALLBACK_ORDER.indexOf(currentTier);
  if (idx === -1 || idx >= TIER_FALLBACK_ORDER.length - 1) return null;
  return TIER_FALLBACK_ORDER[idx + 1];
};

const MODEL_TIERS = [
  {
    value: "fast",
    icon: "far fa-bolt",
    label: "Fast",
    latency: "< 3s",
    tooltipTitle: "Fast Mode",
    bestFor: "Quick replies, SMS, greetings",
    description:
      "Use when you need instant responses for simple, short messages.",
  },
  {
    value: "standard",
    icon: "far fa-balance-scale",
    label: "Standard",
    latency: "3-8s",
    tooltipTitle: "Standard Mode",
    bestFor: "Emails, longer messages",
    description:
      "Balanced quality and speed for most recruiting communications.",
  },
  {
    value: "reasoning",
    icon: "far fa-brain",
    label: "Reasoning",
    latency: "10-30s",
    tooltipTitle: "Reasoning Mode",
    bestFor: "Math, calculations, analysis",
    description:
      "Use for commission calculations, complex comparisons, or detailed logic.",
  },
];

export default MODEL_TIERS;
